<template>
  <div class="p-12">
    <h3 class="font-bold mb-12">New Subscription</h3>

    <div>
      <CreateAccountSubscriptionForm
        :account-id="accountId"
        :agency-options="agencyOptions"
        :billing-period-options="billingPeriodOptions"
        :membership-product-options="membershipProductOptions"
        @create-account-subscription-form:cancel="doGoBack"
        @create-account-subscription-form:created="doGoBack"
      />
    </div>
  </div>
</template>

<script>
import CreateAccountSubscriptionForm from '@/components/AccountSubscriptions/CreateAccountAccountSubscriptionForm.vue';
import { accountAccountSubscriptionsClient } from '@/api/clients';
import { middleware } from '@/routes/guards';

export default {
  components: {
    CreateAccountSubscriptionForm,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      agencyOptions: [],
      billingPeriodOptions: [],
      membershipProductOptions: [],
    };
  },
  async beforeRouteEnter(to, from, next) {
    const check = middleware('account-permission:create account subscriptions');

    check(to, from, async (...args) => {
      if (args.length) {
        return next(...args);
      }

      try {
        const { data = {} } = await accountAccountSubscriptionsClient.create(to.params.accountId);

        return next((vm) => {
          vm.setData(data);
        });
      } catch (error) {
        return next(false);
      }
    });
  },
  methods: {
    setData(data) {
      this.agencyOptions = data?.agency_options || [];
      this.billingPeriodOptions = data?.billing_period_options || [];
      this.membershipProductOptions = data?.membership_product_options || [];
    },
    doGoBack() {
      this.$router.back();
    },
  },
};
</script>
